import Badge from "../../components/badges/Badges";
import { InfoBoard } from "../../components/infoBoard/InfoBoard";
import { Company } from "../../model/Companies";
import { APP_USE, AppUseType, UserData } from "../../model/Users";
import { convertDateTimeToString, convertDateToString } from "../../utility/ConvertUtily";

export type UserProps = {
  userData: UserData;
  company: Company;
  appUse: AppUseType | undefined;
  option: boolean;
}

export const UserRef = ({
  userData,
  company,
  appUse,
  option
}: UserProps) => {

  // 誕生日の型を判定
  const birthDate = Number.isNaN(userData?.birthDate?.getTime()) ? undefined : userData?.birthDate;
  const name = `${userData.lastName !== undefined && userData.lastName !== '' ? userData.lastName : "未登録"}`
  const nameKana = userData.lastNameKana !== undefined && userData.lastNameKana !== '' ? userData.lastNameKana : '';
  let age: number | undefined = undefined;
  if(birthDate !== undefined){
    const today = new Date();
    const thisYearsBirthday = new Date(today.getFullYear(), birthDate.getMonth(), birthDate.getDate());
    age = today.getFullYear() - birthDate.getFullYear();
    if(today < thisYearsBirthday){
      age--;
    }
  }
  const ageString = age !== undefined ? `(${age}歳)` : '';
  //初回ログイン日時
  const firstLoginDate = Number.isNaN(userData?.firstLoginDate?.getTime()) ? undefined : userData?.firstLoginDate;
  const file: { [key: string]: any } = {
    '作成日': convertDateTimeToString(userData?.createAt ?? new Date()),
    '更新日': convertDateTimeToString(userData?.updateAt),
    '生年月日': birthDate !== undefined ? convertDateToString(birthDate) : '',
    '性別': userData.sex === undefined ? '' : userData.sex === 0
      ? '男' : userData.sex === 1 ? '女' : 'その他',
    '所属グループ': userData.groups.map(
      (group, index) => (
        <Badge
          key={`${group}${index}${userData.id}`}
          color={group.color}
          className={group.disabled ? "opacity-30" : ""}>
          {group.name}
        </Badge>
      )),
    'イベント参加履歴メール配信先': (
      <ul>
        {
          userData.familyEmail?.split(",").map(
            (email, index) => (
              <li key={`${email}${index}`}>{email}</li>
            )
          )
        }
      </ul>
    ),
    '郵便番号': userData.zipCode,
    '住所': userData.address,
    '電話番号': userData.phoneNumber,
    'FAX番号': userData.faxNumber,
    '検索キー1': userData.searchKey1,
    'オプション設定': option ? (
      userData.pointAssignmentAuthority ? (
        <Badge color="green">ポイント管理：利用可</Badge>
      ) : (
        <Badge color="red">ポイント管理：利用不可</Badge>
      )
    ) : (<></>),
    '検索キー2': userData.searchKey2,
    '備考': userData.note,
    '検索キー3': userData.searchKey3,
    '初回ログイン日時': firstLoginDate != undefined ? convertDateTimeToString(firstLoginDate) : '',
  };

  return (
    <>
      <div className={"m-6"}>
        <div className="max-w-5xl px-3 sm:px-6 lg:px-8">
          <div className="flex space-x-2 min-w-fix flex-1">
            <h2 className="truncate text-2xl font-bold text-gray-900">
              <ruby>{name}<rt>{nameKana}</rt></ruby> {ageString}
            </h2>
            {userData?.admin === undefined
              ? (<></>) : userData?.admin
              ? (<Badge color="green">運営者アプリ利用可</Badge>) : (<Badge color="red">運営者アプリ利用不可</Badge>)
            }
            {appUse === APP_USE.SUSPEND
              ? (<Badge color="gray">アプリ利用停止</Badge>) : appUse === undefined
              ? (<></>) : appUse === APP_USE.UNUSEABLE
              ? (<Badge color="red">アプリ利用不可</Badge>) : (<Badge color="green">アプリ利用可</Badge>)
            }
          </div>
          <h3>利用者番号: {userData.id.substring(userData.id.indexOf(company.displayId) + company.displayId.length)}</h3>
        </div>
        <InfoBoard col={"col2"} gapX={"gapX36"} gapY={"gapY4"} filed={file} children={undefined} />
      </div>
    </>
  )
}